module.exports = __webpack_public_path__ + "img/gas-pump-slash.95565da8.svg";